import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'react-select';
import { Button, Label, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';

import {
  PUBLISH_CONFIGURATION,
  PUBLISH_CONFIGURATION_EMPTY,
  REVOKE_CONFIGURATION,
  REVOKE_CONFIGURATION_EMPTY,
} from '../../../../../../../../store/actions';

const PublishConfiguration = ({ onClose, currentSelectedBooking, actionType }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { publishConfiguration, publishConfigurationLoading, revokeConfiguration, revokeConfigurationLoading } = useSelector(state => ({
    publishConfiguration: state?.PublishConfiguration?.data,
    publishConfigurationLoading: state?.PublishConfiguration?.loading,

    revokeConfiguration: state?.RevokeConfiguration?.data,
    revokeConfigurationLoading: state?.RevokeConfiguration?.loading,
  }));

  const handleSubmit = () => {
    if (actionType === 'publish') {
      dispatch({
        type: PUBLISH_CONFIGURATION,
        payload: {
          id: currentSelectedBooking?.id,
        },
      });
    } else {
      dispatch({
        type: REVOKE_CONFIGURATION,
        payload: {
          id: currentSelectedBooking?.id,
        },
      });
    }
  };

  useEffect(() => {
    if (revokeConfigurationLoading || publishConfigurationLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [revokeConfigurationLoading, publishConfigurationLoading]);

  useEffect(() => {
    if (publishConfiguration !== null) {
      dispatch({
        type: PUBLISH_CONFIGURATION_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: PUBLISH_CONFIGURATION_EMPTY,
      });
    };
  }, [publishConfiguration]);

  useEffect(() => {
    if (revokeConfiguration !== null) {
      dispatch({
        type: REVOKE_CONFIGURATION_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: REVOKE_CONFIGURATION_EMPTY,
      });
    };
  }, [revokeConfiguration]);

  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose}></ModalHeader>

      <ModalBody>
        <p className="fs-22 text-center">Are you sure you want to {actionType} this configuration</p>
      </ModalBody>

      <div className="d-flex justify-content-center mb-4 gap-3">
        {!loading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        )}

        {loading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}

        <Button color="white" style={{ fontSize: '14px', width: '100px', borderRadius: '10px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
};

export default PublishConfiguration;
